module.exports = __webpack_public_path__ + "static/media/29.d0d187a6.gif";